function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var participantEntities = function participantEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byInvestmentPartyIdAndUserId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_PARTICIPANTBYINVESTMENTPARTYIDANDUSERID_SUCCESS:
      var byInvestmentPartyIdAndUserId = _objectSpread({}, state.byInvestmentPartyIdAndUserId);
      var key = [action.investmentPartyId, action.userId].join("-");
      byInvestmentPartyIdAndUserId[key] = action.response;
      return Object.assign({}, state, {
        byInvestmentPartyIdAndUserId: byInvestmentPartyIdAndUserId
      });
    case ActionTypes.GET_INVESTMENTPARTYVIEWBYINVESTMENTPARTYIDANDPARTICIPANTUSERID_SUCCESS:
      var byInvestmentPartyIdAndUserId = _objectSpread({}, state.byInvestmentPartyIdAndUserId);
      merge(byInvestmentPartyIdAndUserId, action.response.participantByInvestmentPartyIdAndUserId);
      return Object.assign({}, state, {
        byInvestmentPartyIdAndUserId: byInvestmentPartyIdAndUserId
      });
    case ActionTypes.POST_PARTICIPANT_SUCCESS:
      var byInvestmentPartyIdAndUserId = _objectSpread({}, state.byInvestmentPartyIdAndUserId);
      var embedded = action.response._embedded;
      var key = [embedded.investmentParty.id, embedded.user.email].join("-");
      byInvestmentPartyIdAndUserId[key] = embedded;
      return Object.assign({}, state, {
        byInvestmentPartyIdAndUserId: byInvestmentPartyIdAndUserId
      });

    // case ActionTypes.DELETE_PARTICIPANT_SUCCESS:
    //   var byCurrencyIdAndGoalIdAndUserIdAndStateIn = { ...state.byFolloweeIdAndConfirmedAtIsNull }
    //   Object.keys(state.byCurrencyIdAndGoalIdAndUserIdAndStateIn).map(key => {
    //     byCurrencyIdAndGoalIdAndUserIdAndStateIn[key] = state.byCurrencyIdAndGoalIdAndUserIdAndStateIn[key]
    //         .filter(participant => participant.id !== action.participant.id)
    //   })
    //   var byCurrencyIdAndGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan = { ...state.byCurrencyIdAndGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan }
    //   Object.keys(state.byCurrencyIdAndGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan).map(key => {
    //     byCurrencyIdAndGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan[key] = state.byCurrencyIdAndGoalIdAndUserIdAndStateIn[key]
    //         .filter(participant => participant.id !== action.participant.id)
    //   })
    //   var byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan = { ...state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan }
    //   Object.keys(state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan).map(key => {
    //     byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan[key] = state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan[key]
    //         .filter(participant => participant.id !== action.participant.id)
    //   })
    //   var byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan = { ...state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan }
    //   Object.keys(state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan).map(key => {
    //     byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan[key] = state.byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan[key]
    //         .filter(participant => participant.id !== action.participant.id)
    //   })
    //   var byUserId = { ...state.byUserId }
    //   Object.keys(state.byUserId).map(key => {
    //     byUserId[key] = state.byUserId[key].filter(participant => participant.id !== action.participant.id)
    //   })
    //   var byId = { ...state.byId }
    //   delete byId[action.participant.id]
    //   var byBrokerId = { ...state.byBrokerId }
    //   Object.keys(state.byBrokerId).map(key => {
    //     byId[byBrokerId] = state.byId[byBrokerId]
    //         .filter(participant => participant.id !== action.participant.id)
    //   })

    //   return Object.assign({}, state, {
    //     byCurrencyIdAndGoalIdAndUserIdAndStateIn,
    //     byCurrencyIdAndGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan,
    //     byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountGreaterThan,
    //     byGoalIdAndUserIdAndStateInAndRequestedCurrencyAmountLessThan,
    //     byUserId,
    //     byId,
    //     byBrokerId
    //   })

    default:
      return state;
  }
};
export default participantEntities;